import values from 'lodash/values';
import orderBy from 'lodash/orderBy';

const defaultInitialState = {
	columns: {
		created_at: {
			index: 'created_at',
			title: 'Date',
			direction: 'desc',
			className: 'date'
		},
		name: {
			index: 'name',
			title: 'Name',
			direction: 'desc',
			className: 'name'
		},
		email: {
			index: 'email',
			title: 'Email',
			direction: 'desc',
			className: 'email'
		},
		product: {
			index: 'product',
			title: 'Product',
			direction: 'desc',
			className: 'product'
		},
		website: {
			index: 'website',
			title: 'Website',
			direction: 'desc',
			className: 'web-site'
		},
		payout: {
			index: 'payout',
			title: 'Reward',
			direction: 'desc',
			className: 'reward'
		},
		actions: {
			title: 'Actions',
			className: 'actions'
		}
	},
	sortByColumn: {
		index: 'created_at',
		title: 'Date',
		direction: 'desc'
	},
	shownNewsOffers: {}
};

const createTable = ({ namespace }) => {
	const SORT_BY_COLUMN = `${namespace}/table-sort-by-column`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		sortByColumn: columnIndex => ({
			type: SORT_BY_COLUMN,
			payload: columnIndex
		})
	};

	// reducers
	const reducers = {
		[SORT_BY_COLUMN]: (state, action) => {
			const { sortByColumn, columns } = state.table;
			const columnIndex = action.payload;
			const direction = sortByColumn['index'] === columnIndex
				? sortByColumn.direction === 'desc' ? 'asc' : 'desc'
				: columns[columnIndex].direction;

			return {
				...state,
				table: {
					...state.table,
					sortByColumn: {
						...columns[columnIndex],
						direction
					}
				}
			};
		}
	};

	// selectors
	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sortColumns(data, table.sortByColumn) : [];

			return {
				headers: values(table.columns),
				rows: rows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length
			};
		}
	};

	return {
		initialState,
		selectors,
		actions,
		reducers
	};
};

// functions
const sortColumns = (rows, sortedColumn) => {
	if (!rows) return null;
	return orderBy(
		rows,
		row => {
			const value = sortedColumn.index === 'created_at' ? row.created_at : row[sortedColumn.index];

			switch (sortedColumn.index) {
				case 'payout':
					return Number(value);
				default:
					return value;
			}
		},
		sortedColumn.direction
	);
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/advertisers-requests/components/table/index.js